import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Mississippi = () => {
  return (
    <StatePropertyTaxPage
      stateName="Mississippi"
      processDescription="Property owners can inspect assessment rolls in July. Protests must be filed with the Board of Supervisors on or before August 1. Appeals are typically in writing and may require evidence of valuation error."
      noticeOfValueMailed="June"
      noticeOfValueMailedDateExplanation="Notice of Value (Assessment Notice): While specific mailing dates may differ, some counties have been observed to send out notices of new valuations around May or June, particularly in years where there are significant changes to assessments."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Mississippi statutes require property to be assessed as of January 1 each year (Mississippi Code § 27-35-3). This assessment date ensures consistent property valuations across all counties in Mississippi."
      deadlineExplanation="Property owners must file protests with the Board of Supervisors typically by the end of July (before first Monday in August). There are multiple appeal levels: informal appeals per notice, Board of Supervisors appeals, Board of Tax Appeals, and court appeals within 30 days of BTA decision."
    />
  );
};

export default Mississippi;